import { useEffect } from 'react';
import { FocusHandler, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { generateUntactDepartmentListItemFocusKey } from '@pages/Main/focuskey';
import { UntactTvBanner } from '@api/GoodocAPI';

import * as styles from './styles';
import { replaceNewLineCharacter } from '@utils/textUtil';

interface UntactBannerItemProps {
  banner: UntactTvBanner;
  index: number;
  onFocus: FocusHandler;
  showAdvertisement: (banner: UntactTvBanner) => void;
  onEnterPress: () => void;
}

const UntactBannerItem: React.FC<UntactBannerItemProps> = (props) => {
  const { index, banner, showAdvertisement, onFocus, onEnterPress } = props;

  const { ref, focused } = useFocusable({
    focusKey: generateUntactDepartmentListItemFocusKey(index),
    onFocus,
    onEnterPress
  });

  useEffect(() => {
    if (focused) {
      showAdvertisement(banner);
    }
  }, [focused]);

  return (
    <div
      css={[
        styles.container,
        banner.backgroundColor !== 'transparent' && {
          backgroundColor: banner.backgroundColor
        },
        focused && styles.focused
      ]}
      ref={ref}
    >
      <div css={styles.iconContainer}>
        <img src={banner.cardImage} alt={banner.title} css={styles.icon} />
      </div>
      <div css={styles.textContainer}>
        <p css={styles.title}>{replaceNewLineCharacter(banner.title)}</p>
        <p css={styles.description}>{replaceNewLineCharacter(banner.subtitle)}</p>
      </div>
    </div>
  );
};

export default UntactBannerItem;
